import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { getPrePackSize } from "@faire/retailer-visitor-shared/features/PrePacks/getPrePackSize";
import { isPrePackProductOption } from "@faire/retailer-visitor-shared/features/PrePacks/isPrePackProduct";
import { logAssert } from "@faire/web--source/common/logging";
import { formatMoney } from "@faire/web--source/common/money";
import { IFaireMoney } from "@faire/web-api--source/indigofair/data/IFaireMoney";
export var productRetailPriceMoney = function(selectedOption) {
    var _selectedOption_retail_price;
    if (!(selectedOption === null || selectedOption === void 0 ? void 0 : (_selectedOption_retail_price = selectedOption.retail_price) === null || _selectedOption_retail_price === void 0 ? void 0 : _selectedOption_retail_price.amount_cents)) {
        return null;
    }
    var price = selectedOption.retail_price;
    if (isPrePackProductOption(selectedOption)) {
        var prePackUnitCount = getPrePackSize(selectedOption.sizing_quantity);
        logAssert(prePackUnitCount !== 0 || !isNaN(prePackUnitCount), "Prepack unit count is invalid", {
            data: {
                selectedOption: selectedOption
            }
        });
        price = IFaireMoney.build(_object_spread_props(_object_spread({}, price), {
            amount_cents: price.amount_cents / prePackUnitCount
        }));
    }
    return price;
};
export var productRetailPrice = function(selectedOption) {
    var price = productRetailPriceMoney(selectedOption);
    if (!price) {
        return "--";
    }
    return formatMoney({
        money: price
    });
};
